import {
  Amount,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from '@razorpay/blade/components';
import React from 'react';
import { PreviewCTCBreakdown } from '../types';

const PreviewCtcTable = ({
  earning,
  columnTitles,
}: {
  earning?: PreviewCTCBreakdown[keyof PreviewCTCBreakdown];
  columnTitles: string[];
}) => {
  if (earning?.length === 0) return <> </>;
  return (
    <Table
      rowDensity="compact"
      backgroundColor="transparent"
      data={{
        nodes: earning ?? [],
      }}>
      {(tableData) => {
        return (
          <>
            <TableHeader>
              <TableHeaderRow>
                {columnTitles.map((title, index) => (
                  <TableHeaderCell key={title} textAlign={index === 0 ? 'left' : 'right'}>
                    {title}
                  </TableHeaderCell>
                ))}
              </TableHeaderRow>
            </TableHeader>
            <TableBody>
              {tableData.map((item) => {
                return (
                  <TableRow key={item?.name} item={item}>
                    <TableCell>{item?.name}</TableCell>
                    <TableCell textAlign="right">
                      <Amount value={Number(item.amount ?? 0)} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </>
        );
      }}
    </Table>
  );
};
export default PreviewCtcTable;
